import { render, staticRenderFns } from "./GestionDocumentos.vue?vue&type=template&id=f28965ac&scoped=true"
import script from "./GestionDocumentos.vue?vue&type=script&lang=js"
export * from "./GestionDocumentos.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./GestionDocumentos.vue?vue&type=style&index=1&id=f28965ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28965ac",
  null
  
)

export default component.exports